module.exports = { BaseComponent: function BaseComponent() {} };